
import {
  MailIcon,
  MapPinIcon,
  PhoneIcon,
} from "lucide-react";

import { site } from "../../config/site";
import { trackEvent } from "../../lib/tracking";
import metaBadgeUrl from "../../Images/meta-tech-provider.svg";

const legal = [
  ["Privacy Policy", site.links.privacy],
  ["Terms & Conditions", site.links.terms],
  ["Cancellation & Refund", site.links.refund],
  ["Cookie Policy", site.links.cookies],
];

export function SiteFooter() {
  return (
    <footer className="bg-black pb-24 text-on-dark-muted md:pb-0">
      <div className="mx-auto grid max-w-[1140px] gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
        <div className="flex flex-col gap-3">
          <a
            href={site.links.home}
            aria-label="Onbbits home"
            className="w-fit"
          >
            <img
              src={site.logoUrl}
              alt="Onbbits"
              width={140}
              height={32}
              className="h-8 w-auto"
            />
          </a>

          <p className="text-sm font-light leading-relaxed">
            {site.legalName}
          </p>

          <p className="text-sm font-light">
            CIN: {site.cin}
          </p>

          <img
            src={metaBadgeUrl}
            alt="Meta Tech Provider | Onbbits"
            height={40}
            className="mt-3 h-10 w-auto self-start object-contain"
          />
        </div>

        <div className="flex flex-col gap-3">
          <h2 className="text-lg font-semibold text-brand-bright">
            Contact
          </h2>

          <p className="flex gap-2 text-sm font-light leading-relaxed">
            <MapPinIcon
              className="mt-0.5 size-4 shrink-0"
              aria-hidden="true"
            />
            {site.address}
          </p>

          <a
            href={site.phoneHref}
            onClick={() =>
              trackEvent("call_click", { location: "footer" })
            }
            className="flex w-fit items-center gap-2 text-sm hover:text-white"
          >
            <PhoneIcon className="size-4" aria-hidden="true" />
            {site.phoneDisplay}
          </a>

          <a
            href={`mailto:${site.email}`}
            className="flex w-fit items-center gap-2 text-sm hover:text-white"
          >
            <MailIcon className="size-4" aria-hidden="true" />
            {site.email}
          </a>
        </div>

        <nav aria-label="Legal" className="flex flex-col gap-3">
          <h2 className="text-lg font-semibold text-brand-bright">
            Legal
          </h2>

          {legal.map(([label, href]) => (
            <a
              key={label}
              href={href}
              className="w-fit text-sm font-light hover:text-white"
            >
              {label}
            </a>
          ))}
        </nav>
      </div>

      <div className="border-t border-white/10">
        <p className="mx-auto max-w-[1140px] px-4 py-5 text-xs font-light sm:px-6">
          © {new Date().getFullYear()} {site.legalName} All rights reserved.
          WhatsApp is a trademark of Meta Platforms, Inc.
        </p>
      </div>
    </footer>
  );
}
